var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.912 40.2754C1.04612 41.1151 0 42.0486 0 43.034C0 46.6909 14.3271 49.6548 32 49.6548C49.6729 49.6548 64 46.6909 64 43.034C64 42.0486 62.9539 41.1151 61.088 40.2754C56.0309 42.554 44.9104 44.1374 32 44.1374C19.0896 44.1374 7.96912 42.554 2.912 40.2754Z",
    fill: "url(#paint0_linear_2964_9723)",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49.6549C14.3271 49.6549 0 46.6911 0 43.0342V55.1721C0 58.8289 14.3271 61.7928 32 61.7928C49.6729 61.7928 64 58.8289 64 55.1721V43.0342C64 46.6911 49.6729 49.6549 32 49.6549Z",
    fill: "url(#paint1_linear_2964_9723)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.912 22.6212C1.04612 23.4608 0 24.3943 0 25.3797C0 29.0366 14.3271 32.0005 32 32.0005C49.6729 32.0005 64 29.0366 64 25.3797C64 24.3943 62.9539 23.4608 61.088 22.6211C56.0309 24.8997 44.9104 26.4832 32 26.4832C19.0896 26.4832 7.96912 24.8997 2.912 22.6212Z",
    fill: "url(#paint2_linear_2964_9723)",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14.3454C14.3271 14.3454 0 11.3815 0 7.72461V19.8625C0 20.8479 1.04712 21.7814 2.912 22.6211C7.96912 24.8997 19.0896 26.4832 32 26.4832C44.9104 26.4832 56.0309 24.8997 61.088 22.6211C62.9529 21.7815 64 20.848 64 19.8626V7.72461C64 11.3815 49.6729 14.3454 32 14.3454Z",
    fill: "url(#paint3_linear_2964_9723)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32.0006C14.3271 32.0006 0 29.0368 0 25.3799V37.5178C0 38.5031 1.04712 39.4366 2.912 40.2764C7.96912 42.5551 19.0896 44.1385 32 44.1385C44.9104 44.1385 56.0309 42.555 61.088 40.2764C62.9529 39.4368 64 38.5033 64 37.5179V25.38C64 29.0368 49.6729 32.0006 32 32.0006Z",
    fill: "url(#paint4_linear_2964_9723)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2.20703C14.3271 2.20703 0 4.06741 0 7.72428C0 11.3812 14.3271 14.345 32 14.345C49.6729 14.345 64 11.3812 64 7.72428C64 4.06741 49.6729 2.20703 32 2.20703Z",
    fill: "url(#paint5_linear_2964_9723)",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6897 18.7588H35.3104C35.9196 18.7588 36.4139 19.2532 36.4139 19.8623C36.4139 20.4714 35.9196 20.9658 35.3104 20.9658H28.6897C28.0806 20.9658 27.5862 20.4714 27.5862 19.8623C27.5863 19.2532 28.0806 18.7588 28.6897 18.7588Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6897 36.4141H35.3104C35.9196 36.4141 36.4139 36.9084 36.4139 37.5176C36.4139 38.1267 35.9196 38.6211 35.3104 38.6211H28.6897C28.0806 38.6211 27.5862 38.1267 27.5862 37.5176C27.5863 36.9084 28.0806 36.4141 28.6897 36.4141Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6897 54.0693H35.3104C35.9196 54.0693 36.4139 54.5637 36.4139 55.1728C36.4139 55.782 35.9196 56.2763 35.3104 56.2763H28.6897C28.0806 56.2763 27.5862 55.782 27.5862 55.1728C27.5863 54.5637 28.0806 54.0693 28.6897 54.0693Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2964_9723",
    x1: 1.2241e-7,
    y1: 44.9282,
    x2: 64,
    y2: 44.9281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6800B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2964_9723",
    x1: 1.2241e-7,
    y1: 52.3396,
    x2: 64,
    y2: 52.3396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#611EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66A2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2964_9723",
    x1: 1.2241e-7,
    y1: 27.2739,
    x2: 64,
    y2: 27.2739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6800B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2964_9723",
    x1: 1.2241e-7,
    y1: 17.0301,
    x2: 64,
    y2: 17.0301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#611EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66A2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2964_9723",
    x1: 1.2241e-7,
    y1: 34.6853,
    x2: 64,
    y2: 34.6853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#611EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66A2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2964_9723",
    x1: 1.2241e-7,
    y1: 8.22824,
    x2: 64,
    y2: 8.22824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6800B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.1f414f100844eedded63e87e51a049d5.svg";
export { ForwardRef as ReactComponent };